import React from "react";
import comparisonBg from "../../../images/bg/comparison-bg.png";

interface ComparisonItem {
  title: string;
  icon: string;
  points: string[];
}

const ComparisonSection: React.FC = () => {
  const comparisons: ComparisonItem[] = [
    {
      title: "Without SMMPanel-Cheap",
      icon: "❌",
      points: [
        "Paying high prices for basic SMM services",
        "Waiting hours for orders to start",
        "Unreliable providers and random drops",
        "No refill when followers disappear",
        "Slow or non-existent support",
        "Managing every platform manually",
      ],
    },
    {
      title: "With SMMPanel-Cheap",
      icon: "✅",
      points: [
        "Lowest prices starting from $0.01 per 1000",
        "Orders that start in seconds, 24/7",
        "Automatic refill on eligible services",
        "One dashboard for every social platform",
        "Fast, human support day and night",
        "Scale every campaign without the headache",
      ],
    },
  ];

  return (
    <section className="comparison-container mt-5">
      <div className="row mt-none-30">
        {comparisons.map((block, index) => (
          <div className="col-lg-6 mt-30" key={index}>
            <div
              className={`comparison-list xb-border bg_img ${
                index === 0 ? "comparison--without" : "comparison--with"
              }`}
              style={{ backgroundImage: `url(${comparisonBg})` }}
            >
              <h3 className="xb-item--title">{block.title}</h3>

              <ul className="xb-item--list list-unstyled">
                {block.points.map((point, i) => (
                  <li key={i}>
                    <span className="comparison-icon">{block.icon}</span>
                    {point}
                  </li>
                ))}
              </ul>

              {/* Center "v/s" icon only on first block */}
              {index === 0 && (
                <span className="comparison-vs-logo xb-border">v/s</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ComparisonSection;
